import { sdk } from 'src/utilities/sdk';
import { Employee } from 'src/types/Employee';
import { decamelizeRequestBody } from 'src/utilities/http-data-casing';

export const getEmployeeUpdateEndpoint = (
  corpId: string,
  employeeId: string
): string => `/corp-admin/${corpId}/diners/${employeeId}`;

export function updateEmployee(
  corpId: string,
  employeeId: string,
  employeeData: Employee
): Promise<void> {
  const decamelizedEmployeeData = decamelizeRequestBody(
    employeeData
  ) as unknown as Employee;

  return sdk.http.put(
    getEmployeeUpdateEndpoint(corpId, employeeId),
    decamelizedEmployeeData
  );
}
